var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n\n  > .loading {\n    width: 100%;\n    height: 68px;\n    position:absolute;\n    top: 50%;\n    margin-top: -34px;\n    text-align: center;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  position: relative;\n\n  > .loading {\n    width: 100%;\n    height: 68px;\n    position:absolute;\n    top: 50%;\n    margin-top: -34px;\n    text-align: center;\n  }\n"])));
export default (function () {
    return (React.createElement(RootDiv, null,
        React.createElement("div", { className: "loading" },
            React.createElement("div", { className: "lds-ring" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null)))));
});
var templateObject_1;
